import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "../VendorDiscontinueChangeApprove/GCAutocompleteCheckboxFixSizeUid";
import ApproveModal from "./RSPChangeApproveDetail";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import Breadcrumbs from "./Components/Breadcrumbs";
import { getStatusStyleV1 } from "../../Utility/Utilitys";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import {
  GET_API_RSP_Change_Approve_Detail_Summary_GetRow,
  GET_API_RSP_Change_Approve_Summary_GetRow,
} from "../../Server/ApiV2";
import { useLocation } from "react-router-dom";

export default function RSPChangeApproveSummary() {
  const status = ["All", "Enter", "Post"];
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const queryParams = useLocation();
  const pageType = queryParams.search.split("type=")[1];
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();

  const Location = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const { UserID } = useSelector((state) => state.login.value);

  const headInitial = {
    A_TransId: "",
    A_Date: "",
    A_Loc: "",
    Loc_Name: "",
    A_Narration: "",
    A_Status: "",
    CreatedBy: "",
    CreatedDate: "",
    ApproveStatus: "",
    A_StatusCM: "",
    A_StatusPM: "",
    A_CM_By: "",
    A_CM_Dt: "",
    A_PM_By: "",
    A_PM_Dt: "",
    ApprovedBy: "",
    ApproveDt: "",
    A_LocCSV: "",
    LoccsvName: "",
  };

  const initialState = {
    dateFrom: moment().startOf("month").toDate(),
    dateTo: moment().toDate(),
    location: Location?.map((item) => item.Uid),
    status: "All",
  }

  // local state
  const [open, setOpen] = useState(false);
  const [RowData, setRowData] = useState([]);
  const [DetailData, setDetailData] = useState([]);
  const [headObj, setHeadObj] = useState(headInitial);

  const [filterObj, setFilterObj] = useState(initialState);

  const summaryGetRow = async () => {
    const sumFilterRes = await GET_API_RSP_Change_Approve_Summary_GetRow({
      FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      Location:
        filterObj?.location.length > 0 ? filterObj?.location.join(",") : "",
      Status: filterObj?.status,
      UserCd: UserID || "",
      Type: pageType,
    });
    if (sumFilterRes?.status === 200)
      setRowData(sumFilterRes?.data?.recordset || []);
  };

  const handleRowClick = (params) => {
    setHeadObj((prev) => ({ ...prev, ...params.row }));
    setOpen(true);
    loadDetail(params?.row?.A_TransId);
  };

  const loadDetail = async (transId) => {
    try {
      const res = await GET_API_RSP_Change_Approve_Detail_Summary_GetRow({
        TransId: transId ? transId : headObj?.A_TransId,
      });
      if (res?.status === 200) setDetailData(res?.data?.ResultSet || []);
    } catch (error) {}
  };

  const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };

  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

    useEffect(() => {
    setFilterObj((prev) => ({
      ...prev,
      ...initialState,
    }));
    setRowData([])
  }, [pageType]);

  return (
    <>
      <Breadcrumbs pageType={pageType} />
      <Grid
        container
        spacing={{ xs: 1, sm: 1.5 }}
        sx={{ marginTop: "16px !important" }}
      >
        <Grid item xs={6} sm={3} md={1.7}>
          <CmpDatePickerField001V1
            xLabelText="From Date"
            xName={"dateFrom"}
            xValue={filterObj?.dateFrom}
            xOnChange={(newValue) => {
              setFilterObj((prev) => ({
                ...prev,
                dateFrom: newValue.$d,
              }));
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={1.7}>
          {/* <Typography>To Date</Typography> */}
          <CmpDatePickerField001V1
            xLabelText="To Date"
            xName={"dateTo"}
            xValue={filterObj?.dateTo}
            xOnChange={(newValue) => {
              setFilterObj((prev) => ({
                ...prev,
                dateTo: newValue.$d,
              }));
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3.4}>
          <GCAutocompleteCheckboxFixSizeUid
            options={Location}
            xValue={filterObj?.location}
            setValue={(updatedObj) => {
              setFilterObj((prev) => ({
                ...prev,
                location: updatedObj,
              }));
            }}
            objName="location"
            label="Location"
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={3} md={1.8}>
          {/* <Typography>Status</Typography> */}
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              size="small"
              value={filterObj?.status}
              name="status"
              label="Status"
              onChange={(e) => {
                setFilterObj((prev) => ({
                  ...prev,
                  status: e.target.value,
                }));
              }}
            >
              {status.map((obj) => (
                <MenuItem key={obj} value={obj}>
                  {obj}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={9}
          md={3.4}
          display="flex"
          alignItems={"center"}
          justifyContent="flex-end"
        >
          <Stack
            direction={"row"}
            columnGap={{ xs: 1, lg: 2 }}
            justifyContent="flex-end"
          >
            <Button variant="contained" size="small" onClick={summaryGetRow}>
              Load
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: { xs: "75vh", sm: "70vh", md: "77vh", lg: "78vh" },
          marginTop: "16px",
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          rows={RowData}
          getRowId={(v) => v.A_TransId}
          columns={[
            {
              field: "A_TransId",
              headerName: "Trans Id",
              width: 60,
              align: "center",
            },
            {
              field: "A_Date",
              headerName: "Date",
              headerAlign: "center",
              align: "center",
              width: 95,
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "Loc_Name",
              headerName: "Trans Location",
              headerAlign: "left",
              align: "left",
              width: 120,
            },
            {
              field: "LoccsvName",
              headerName: "Locations",
              headerAlign: "left",
              minWidth: 200,
              flex: 1,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
              align: "left",
              minWidth: 160,
              flex: 1,
            },

            {
              field: "A_Status",
              headerName: "Status",
              headerAlign: "center",
              width: 75,
              align: "center",
              align: "center",
              headerAlign: "center",
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_StatusCM",
              headerName: "CM Status",
              width: 80,
              align: "center",
              headerAlign: "center",
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_StatusPM",
              headerName: "PM Status",
              width: 80,
              align: "center",
              headerAlign: "center",
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              headerAlign: "center",
              width: 85,
              align: "center",
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              headerAlign: "left",
              align: "left",
              width: 110,
            },
            {
              field: "CreatedDate",
              headerName: "Created Date",
              headerAlign: "center",
              align: "center",
              width: 100,
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 110,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 100,
              headerAlign: "center",
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 110,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 100,
              align: "center",
              headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              headerAlign: "center",
              align: "center",
              width: 110,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              headerAlign: "center",
              align: "center",
              width: 100,
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_VocTyp",
              headerName: "Voc.Type",
              align: "center",
              width: 70,
            },
            {
              field: "A_VocNo",
              headerName: "Voc.No",
              align: "left",
              width: 95,
            },
            {
              field: "A_PromoCsv",
              headerName: "Promo Csv",
              align: "left",
              minWidth: 140,
            },
          ]}
          hideFooter={true}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
          onRowDoubleClick={(params) => handleRowClick(params)}
        />
      </Box>
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title={`RSP Change Approve ${pageType}`}
        children={
          <ApproveModal
            UserID={UserID}
            handleClose={() => setOpen(false)}
            summaryLoad={summaryGetRow}
            HeadObject={headObj}
            setHeadObj={setHeadObj}
            DetailData={DetailData}
            setDetailData={setDetailData}
            Location={Location}
            type={pageType}
          />
        }
      />
    </>
  );
}
